<mat-drawer-container (backdropClick)="closeSideNav()">
  <mat-drawer
    #drawerContentRef
    [mode]="mode"
    position="end"
    role="region"
    [opened]="isOpened$ | async"
    (closedStart)="closeSideNav()"
  >
    <ng-content select="[drawer-content]"></ng-content>
  </mat-drawer>
  <mat-drawer-content #contentRef>
    <ng-content select="[content]"></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
